import React from 'react';
import StyledClientItem from './ClientItem.style';

function ClientItem({ clientName, clientUrl }) {
  return (
    <StyledClientItem>
      <img alt={clientName} src={clientUrl} />
    </StyledClientItem>
  );
}

export default ClientItem;
